import { Component, OnInit } from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {ApiService} from '../api/api.service';

@Component({
  selector: 'app-store',
  templateUrl: './store.component.html',
  styleUrls: ['./store.component.css']
})
export class StoreComponent implements OnInit {

  softwres: any

  constructor(
    private route: ActivatedRoute
  ) {
    window.scroll(0,0)
    this.softwres = this.route.snapshot.data.software;
  }

  ngOnInit() {
  }

}
